import { TFunction } from 'i18next';

/**
 * «היום», «אתמול», «לפני 3 ימים», «לפני חודש»... for a list that answers "is this recent?" before
 * "when exactly?". Past a year it is the date itself. The full date belongs in a tooltip beside it.
 */
export const relativeTime = (iso: string | null | undefined, t: TFunction, locale = 'he-IL'): string => {
  if (!iso) return '';
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return '';
  const days = Math.floor((Date.now() - at.getTime()) / 86_400_000);
  if (days <= 0) return t('relativeTime.today');
  if (days === 1) return t('relativeTime.yesterday');
  if (days < 30) return t('relativeTime.daysAgo', { count: days });
  const months = Math.round(days / 30);
  if (months < 12) return months === 1 ? t('relativeTime.monthAgo') : t('relativeTime.monthsAgo', { count: months });
  return at.toLocaleDateString(locale);
};
